module.exports = __webpack_public_path__ + "media/theme/icon__stock--in-bd790060.svg";